import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'brNumber',
    standalone: false,
})
export class BrNumberPipe implements PipeTransform {

  transform(value: string): any {

    let num = value.toString();
    num = num.replace(/\./g, '-');
    num = num.replace(/\,/g, '.');
    num = num.replace(/\-/g, ',');

    return num;

  }

}
